import type { Route } from '../network/route';
import { CollectionMode } from '../initBlizzard';
import { getCollectionMode } from '../environment';

// SSO Client Ids the SDK supports for authenticated uploads.
export enum SsoClientId {
  SNAPCHAT_COM = 'snapchat-com-metrics',
}

const webAnalyticsV2EndpointSuffix = '/web-analytics-v2/web';

// A mapping of a given SSO Client Id to its base route.
const clientIdRouteMap: { [key in SsoClientId]: Route } = {
  [SsoClientId.SNAPCHAT_COM]: {
    stagingUrl: `https://staging-gcp.api.snapchat.com${webAnalyticsV2EndpointSuffix}`,
    prodUrl: `https://gcp.api.snapchat.com${webAnalyticsV2EndpointSuffix}`,
    spectrumUrl: 'https://gcp.api.snapchat.com/streaming-collector-sso/collect',
  },
};

/**
 * Retrieves the authenticated base url for a given valid SSO Client Id.
 *
 * @internal
 */
export function getAuthBaseUrl(ssoClientId: SsoClientId): string {
  const route = clientIdRouteMap[ssoClientId];
  return getCollectionMode() === CollectionMode.STAGE ? route.stagingUrl : route.prodUrl;
}

/**
 * Retrieves the authenticated spectrum base url for a given valid SSO Client Id.
 *
 * @internal
 */
export function getSpectrumAuthBaseUrl(ssoClientId: SsoClientId): string {
  const route = clientIdRouteMap[ssoClientId];
  return route.spectrumUrl;
}
